import React from 'react';
import getClassNames from '../../utils/className/getClassNames';

// Todo: Cleanup post TS transition
export type TBoxProps = {
  as: keyof React.JSX.IntrinsicElements;
  name: string;
  parent?: string;
  modifiers?: string | string[];
  states?: string | string[];
  utilities?: string | string[];
  htmlNameAttr?: string;
  children?: any;
  // Todo: defaults to extend ...
  className?: string;
  onClick?: (e: any) => void;
  href?: string;
  role?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  id?: string;
  value?: string;
  type?: any; // TODO: input & button types
  checked?: boolean;
  htmlFor?: string;
  tabIndex?: number;
  'aria-label'?: string;
  minRows?: number;
  maxRows?: number;
  required?: boolean;
} & React.HTMLAttributes<any>;

type TInternalProps = {
  className: string;
  name?: string;
  ref?: any;
};

const Box = React.forwardRef(
  (
    {
      as,
      name,
      parent = '',
      modifiers = [],
      states = [],
      utilities = [],
      className = '',
      htmlNameAttr,
      ...rest
    }: TBoxProps,
    ref,
  ) => {
    const As = as;

    const classNames = getClassNames({
      name,
      parent,
      modifiers,
      states,
      utilities,
      custom: className,
    });

    const props: TInternalProps = {
      className: classNames,
    };

    if (ref) {
      props.ref = ref;
    }

    if (htmlNameAttr) {
      props.name = htmlNameAttr;
    }

    // todo: think what we can do about this: TS2590: Expression produces a union type that is too complex to represent.
    // @ts-ignore
    return <As {...props} {...rest} />;
  },
);

Box.displayName = 'Box';

export default React.memo(Box);
